import React from 'react';
import Resizer from 'react-image-file-resizer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isMobile } from 'react-device-detect';
import { TIPO_IMAGEN } from './auth-header';

/**
 * Selector de varias fotos de una vez.
 *
 * Antes habia una ranura (`MiUploadArchivo`) por lado del vehiculo y cada foto entraba
 * por su propio input: para cargar cuatro fotos habia que abrir el explorador cuatro
 * veces. Aca se eligen todas juntas y se procesan en fila.
 *
 * Las fotos se suben de a una igual que antes: `onImagenAgregada` devuelve una promesa y
 * se espera antes de pasar a la siguiente, asi el body nunca lleva mas de un base64.
 */

const MAX_SEGUNDOS_VIDEO = 10;

export default class MiUploadImagenes extends React.Component {

	state = {
		error: undefined,
		procesando: false
	}

	/** Un archivo -> el objeto que espera el array `imagenes` del form. */
	procesarArchivo = (file) => new Promise((resolve, reject) => {
		const docuDe = (base64) => ({
			id: undefined,
			base64,
			tipo: TIPO_IMAGEN.GENERAL,
			nombre: file.name,
			descripcion: file.name,
			temp: true,
			type: file.type
		});

		if (file.type && file.type.startsWith('video')) {
			const video = document.createElement('video');
			video.preload = 'metadata';

			video.onloadedmetadata = () => {
				window.URL.revokeObjectURL(video.src);

				if (video.duration > MAX_SEGUNDOS_VIDEO) {
					reject(new Error(`"${file.name}": el video no puede superar los ${MAX_SEGUNDOS_VIDEO} segundos`));
					return;
				}

				const reader = new FileReader();
				reader.onload = () => resolve(docuDe(reader.result));
				reader.onerror = () => reject(new Error(`No se pudo leer "${file.name}"`));
				reader.readAsDataURL(file);
			};

			video.onerror = () => reject(new Error(`No se pudo leer "${file.name}"`));
			video.src = URL.createObjectURL(file);
			return;
		}

		try {
			Resizer.imageFileResizer(file, 1080, 1080, 'JPEG', 50, 0,
				(base64String) => resolve(docuDe(base64String)), 'base64');
		} catch (err) {
			reject(new Error(`No se pudo procesar "${file.name}"`));
		}
	})

	parsearFiles = async (event) => {
		const { arrayHelpers, onImagenAgregada, cantidadActual, maximo } = this.props;

		const files = Array.from(event.currentTarget.files || []);
		// Sin esto no se puede volver a elegir el mismo archivo (el input no dispara change).
		event.currentTarget.value = '';

		if (files.length === 0) return;

		this.setState({ procesando: true, error: undefined });

		// El contador se lleva local: `cantidadActual` viene del render y no se actualiza
		// mientras dura el for.
		let cargadas = cantidadActual || 0;
		let error;

		for (const file of files) {
			if (maximo && cargadas >= maximo) {
				error = `Sólo se pueden subir ${maximo} fotos por publicación`;
				break;
			}

			try {
				const docu = await this.procesarArchivo(file);
				arrayHelpers.push(docu);
				cargadas++;

				if (onImagenAgregada) await onImagenAgregada();
			} catch (err) {
				error = err.message;
			}
		}

		this.setState({ procesando: false, error });
	}

	render() {
		const { idUnique, maximo, cantidadActual } = this.props;
		const { procesando, error } = this.state;

		const lleno = maximo !== undefined && (cantidadActual || 0) >= maximo;
		const deshabilitado = procesando || lleno;

		return (
			<>
				<div className='form-control--upload'>
					<label htmlFor={idUnique + 'f'} className=''>
						<div className="button" data-type='complementary-smallest'>
							<FontAwesomeIcon icon={procesando ? 'fas fa-spinner' : 'fas fa-file-upload'} spin={procesando} />
							<span className='ms-2'>{procesando ? 'Subiendo…' : 'Elegir fotos'}</span>
						</div>

						<input className="d-none" id={idUnique + 'f'} name={idUnique + 'f'} type="file"
							multiple
							disabled={deshabilitado}
							accept="image/png, image/jpeg, video/*"
							onChange={this.parsearFiles} />
					</label>

					{isMobile && <label htmlFor={idUnique + 'a'} className=''>
						<div className="button" data-type='complementary-smallest'>
							<FontAwesomeIcon icon="fa-solid fa-camera" />
							<span className='ms-2'>Sacar foto</span>
						</div>

						<input className="d-none" id={idUnique + 'a'} name={idUnique + 'a'} type="file"
							disabled={deshabilitado}
							accept="image/png, image/jpeg" capture="environment"
							onChange={this.parsearFiles} />
					</label>}
				</div>

				{error && <div className='text-danger mt-2'>{error}</div>}
			</>
		);
	}
}
